export default __webpack_public_path__ + "gray-warning-icon.svg";